import { setGlobalData } from "slices/global";

export const setupGlobalData = (cartSettings, commitmentBasedDiscounts, isOneTimeCollection) => (dispatch, getState) => {
	const { isClient } = getState().global;

	if (isClient) return;

	dispatch(setGlobalData({
		cartBonus: cartSettings.bonus,
		cartBoxes: cartSettings.boxes,
		commitmentBasedDiscounts,
		isOneTimeCollection
	}));
};